export const baseProps = {
  label: {
    type: String,
    required: true
  },
  obrigatorio: {
    type: Boolean,
    default: false
  },
  Indice: {
    type: Number,
    required: false,
    default: null
  },
  maxlength: {
    type: Number,
    required: false,
    default: null
  },
  vMask: {
    type: [String, Array],
    required: false,
    default: null
  },
  nomeAba: {
    type: String,
    required: false
  },
  widthColumn: {
    type: Number,
    required: false,
    default: 24
  },
  marginLeft: {
    type: Boolean,
    default: false
  }
}



// WEBPACK FOOTER //
// ./src/libs/utils/forms/baseProps.js